import { ApiUrl } from '@common/enums';
import { OptionalProduct } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const mileageTiersApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchMileageTiers: builder.query<OptionalProduct[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.MILEAGE_TIERS_URL,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchMileageTiersQuery } = mileageTiersApi;
